
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M15.821 12.0312L9.15467.65625C8.89949.21875 8.44983 0 7.99983 0c-.45009 0-.90059.21875-1.15753.65625L.179401 12.0312C-.330974 12.9028.307869 14 1.33559 14H14.6649c1.0242 0 1.6665-1.0938 1.1561-1.9688zM1.64327 12.5L7.99855 1.65009 14.3571 12.5H1.64327zm6.35675-2.96491c-.54262 0-.98244.43988-.98244.98241 0 .5426.43982.9825.98244.9825s.9824-.4399.9824-.9825c0-.54253-.43981-.98241-.9824-.98241zm-.75-4.78509v3c0 .41406.33594.75.75.75s.75-.33594.75-.75v-3c0-.41406-.33594-.75-.75-.75s-.75.33594-.75.75z"}})])
          )
        }
      }
    